// AUTO-GENERATED by scripts/write-version.js — do not edit by hand.
// Change version only in the root package.json, then: npm run version:sync
export const APP_NAME = "CITO"
export const APP_VERSION = "2.0.0"
export const APP_DESCRIPTION = "Company Internal Task/Tracking Organizer"
